import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class MerchantDisputantsModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            isDelete: false,
            merchantDisputant: props.isNew ? {} : props.merchantDisputant,
            title: props.isNew ? "New Merchant Disputant" : `Merchant Disputant`,
            updating: false,
            touchedForm: false,
            domainCodeValidity: -1,
            domainNameValidity: -1

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
    }

    onTextInputChange(evt) {

        let merchantDisputant = Object.assign({}, this.state.merchantDisputant);
        merchantDisputant[evt.target.id] = evt.target.value || null;

        let stateUpdate = {
            merchantDisputant,
            touchedForm: true,
        }
        stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;

        this.setState(stateUpdate);
    }
    handleAction(evt) {
        this.setState({ updating: true });

        const merchantDisputant = this.state.merchantDisputant;
        let promise = ArbiterApi.createMerchantDisputant(merchantDisputant);
        promise.then((response) => {
            Toaster.success(Messages.SUCCESS_MERCHANT_DISPUTANT_CREATED);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_MERCHANT_DISPUTANT_CREATE} - ${error.status}`);
                this.setState({ updating: false });
            })
    }

    handleDeleteAction(evt) {
        this.setState({ updating: true });
        const merchantDisputant = this.state.merchantDisputant;
        ArbiterApi.deleteMerchantDisputant(merchantDisputant.id)
            .then((response) => {
                Toaster.success(Messages.SUCCESS_MERCHANT_DISPUTANT_DELETE);
                this.setState({ updating: false });
                this.props.onRequestClose(evt, true);
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_MERCHANT_DISPUTANT_DELETE} - ${error.status}`);
                this.setState({ updating: false });
            });
    }


    render() {
        const isView = this.state.isView;
        const isDelete = this.state.isDelete;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Domain Code :</label>
                                        <label>{this.state.merchantDisputant.domainCode}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Domain Name :</label>
                                        <label>{this.state.merchantDisputant.domainName}</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Domain Code :</label>
                                        <FloatInput
                                            id="domainCode"
                                            value={this.state.merchantDisputant.domainCode}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Code"
                                            maxLength="10"
                                            showError={this.state.domainCodeValidity === 0} errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>
                                    <div className="form-div">
                                        <label>Domain Name :</label>
                                        <FloatInput
                                            id="domainName"
                                            value={this.state.merchantDisputant.waitTime}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Domain Name"
                                            maxLength="50"
                                            showError={this.state.domainNameValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isDelete &&
                    <div className="mod-footer">

                        <div className="mod-footer-buttons">
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isDelete: true }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.DELETE_MERCHANT_DISPUTANT]}>DELETE</CButton>

                            }

                            {!isView  &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.CREATE_MERCHANT_DISPUTANT]}>CREATE</CButton>

                            }
                            <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>

                        </div>
                    </div>
                }
                {isDelete &&
                    <div className="mod-footer">
                        <div className="action-warning">
                            {Messages.ACTION_WARNING}  ?
                                </div>
                        <div className="mod-footer-buttons">
                            <button onClick={(evt) => { this.setState({ isDelete: false }) }} disabled={this.state.updating} className="btn btn-danger">NO</button>
                            <button onClick={(evt) => { this.handleDeleteAction(evt) }} disabled={this.state.updating} className="btn btn-primary">YES</button>

                        </div>
                    </div>
                }
            </Modal>
        )
    }

    formValid() {
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.domainCodeValidity === 1 && this.state.domainNameValidity === 1 ;
      }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(MerchantDisputantsModal, [Permissions.VIEW_MERCHANT_DISPUTANT]));


// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsModal.js